import { DateTime } from "@easepick/bundle";
import { BasePlugin, IBaseConfig } from "@easepick/base-plugin";

interface IBlackoutConfig extends IBaseConfig {
    minDate?: Date | string | number;
    filter?: (date: DateTime | DateTime[], picked: DateTime[]) => boolean;
}

declare module "@easepick/core/dist/types" {
    interface IPickerConfig {
        BlackoutPlugin?: IBlackoutConfig;
    }
}

/**
 * since we need the plugin twice one for booked dates which are inseparable and on for blackouts
 */
export class BlackoutPlugin extends BasePlugin {
    viewHandler: () => void;

    public options: IBlackoutConfig = {
        minDate: null,
        filter: null
    };

    constructor() {
        super();
        this.viewHandler = this.extendOnView.bind(this);
    }

    getName() {
        return "BlackoutPlugin";
    }

    onAttach() {
        this.picker.on("view", this.viewHandler);
    }

    onDetach() {
        this.picker.off("view", this.viewHandler);
    }

    extendOnView(i: CustomEvent): void {
        const { view, target, date } = i.detail;
        if (
            view === "CalendarDay" &&
            "function" === typeof this.options.filter &&
            this.options.filter(date, this.picker.datePicked)
        ) {
            return void target.classList.add("locked", "blackout");
        }
    }
}
